import { countryCodeEnum } from './country'
import { COUNTRY_ISLAND } from './internationalBankTransfer'

export const COUNTRY_CREDIT_CARD_BLACKLIST = [
  countryCodeEnum.INDIA,
  countryCodeEnum.CHINA,
  countryCodeEnum.NETHERLANDS_ANTILLES,
  countryCodeEnum.AFGHANISTAN,
  countryCodeEnum.IRAQ,
  countryCodeEnum.IRAN,
  countryCodeEnum.YEMEN,
  countryCodeEnum.LEBANON,
  countryCodeEnum.SYRIA,
  // countryCodeEnum.TUNISIA,
  countryCodeEnum.MALI,
  countryCodeEnum.LIBYA,
  countryCodeEnum.SOMALIA,
  countryCodeEnum.SUDAN,
  countryCodeEnum.ERITREA,
  countryCodeEnum.PAKISTAN,
  countryCodeEnum.BANGLADESH,
  ...COUNTRY_ISLAND,
]
